import { EXPORT_PAGE_SIZE } from './export-page-size.js';

export function formatExportRequestCount(totalCount: number): string {
  return Math.ceil(totalCount / EXPORT_PAGE_SIZE).toLocaleString();
}
